import { useEffect, useState } from "react";
import { getCurrentUser } from "../api/requests";
import { User } from "../interface/interfaces";
// import { useNotification } from "../context/NotificationContext";

export function useUserLogic(){
    // const {notify}=useNotification()
    const [currentUser,setCurrentUser]=useState<User | null>(null)
    const [isLoading,setIsLoading]=useState(false)

    async function loadUser(){

        let user=null

        try {

            setIsLoading(true)

            let ret:User=await getCurrentUser()

            user=ret 

        } catch (error:any) {

           console.error(error.message)
            
        } finally{     
            setIsLoading(false)
        }


        return user

    }

    useEffect(()=>{
        
        const func=async ()=>{
        let userData=await loadUser()

        setCurrentUser(userData)
        }

        func()

    },[])


  const reloadUser=async ()=>{

   let user=await loadUser()

   setCurrentUser(user)

  }


  return {
    currentUser,
    isLoading,
    reloadUser
  }

}